/** @jsx jsx */
import { Box, jsx, Paragraph } from 'theme-ui';
import { ThemeHeader } from '../../components';
import CTALink from '../CTALink';
import useElementOnScreen from '../../hooks/useElementOnScreen';

import TextBlock from '../TextBlock';

const RenderTextBlock = ({ bilateralTextBlock, carouselStyle }) => {
  // Animation refrences, Animate when element visible on screen
  const [SliderHeadingRef, isSliderHeadingVisible] = useElementOnScreen();
  const [SliderTextRef, isSliderTextVisible] = useElementOnScreen();
  const [SliderCTARef, isSliderCTAVisible] = useElementOnScreen();

  return (
    <Box sx={carouselStyles.sliderTextBlock}>
      <Box ref={SliderHeadingRef} sx={{ transition: 'opacity 1s ease 0.25s', opacity: isSliderHeadingVisible ? 1 : 0 }}>
        <ThemeHeader.H2>{bilateralTextBlock.heading}</ThemeHeader.H2>
      </Box>
      <Paragraph
        ref={SliderTextRef}
        sx={{ ...carouselStyles.sliderText, ...{ transition: 'opacity 1s ease 0.5s', opacity: isSliderTextVisible ? 1 : 0 } }}
      >
        <TextBlock description={bilateralTextBlock?.text} />
      </Paragraph>
      <Box ref={SliderCTARef} sx={{ ...carouselStyles.ctaWrap, ...{ transition: 'opacity 1s ease 0.75s', opacity: isSliderCTAVisible ? 1 : 0 } }}>
        {bilateralTextBlock.ctaLinks?.map((link) => {
          return <CTALink key={link._key} linkData={link} />;
        })}
      </Box>
    </Box>
  );
};

export default RenderTextBlock;

const carouselStyles = {
  sliderTextBlock: {
    maxWidth: [null, null, 530],
  },
  sliderText: {
    mb: 4,
    variant: 'styles.p',
  },
  ctaWrap: {
    variant: 'styles.ctaList',
  },
};
